import './Notifications.scss';

import classNames from 'classnames';
import React from 'react';
import { SonarCard } from '@ui/general';
import { useNotifications } from '@hooks';
import { When } from 'react-if';

import { ClearAllNotifications, NotificationCards } from '@ui/notifications';

export const Notifications: React.FC = () => {
	const count = useNotifications().length;
	const title = `Notifications${count ? ` (${count})` : ''}`;
	const cardClassNames = classNames('notifications-card', { empty: !count });

	return (
		<SonarCard
			className={ cardClassNames }
			extra={
				<When condition={ count }>
					<ClearAllNotifications id='dashboard-notifications-clear-all-button' />
				</When>
			}
			id='notifications-card'
			title={ title }
			titleClassName='h2'>
			<NotificationCards
				className='notifications-card-list'
				height={ 385 } />
		</SonarCard>
	);
};
